export default __webpack_public_path__ + "static/media/turboprop.9abf2c3c.png";